module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai463-40c5dbe0763060036ed273dd37710c6c.jpg";